export enum UserType {
  STANDARD = "standard", // John Doe
  SOCIAL_SEPARATED = "social_separated", // YellowSquare
  FULLSAND = "fullsand", // Fullsand
}
